import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';
import { getCommunityLogoUrl } from 'src/utils/linkUtils';
import FollowButton from 'src/components/buttons/followButton';
import WriteButton from 'src/modules/community/shared/components/writeButton';
import signupContext from 'src/constants/signupContext';
import { userIsMemberOfCurrentGroup } from 'src/utils/context';
import { numberFormat } from 'src/utils/string';
import { hideWriteCTA } from 'src/constants/restrictedCommunities';
import ImageUpload from 'src/components/imageUpload';
import { saveAndCropLogoImage } from 'src/api/community';
import AdminActions from './adminActions';
import { useHelpScout } from 'src/utils/hooks';

const isWriteCTAVisible = (community) => community && !hideWriteCTA.includes(community.slug);

const CommunityHeaderContent = ({ community, currentUser, currentPage }) => {
  const imageUrl = getCommunityLogoUrl(community.logoImageHash);
  const logoStyle = {
    backgroundImage: `url("${imageUrl}")`,
  };
  const isMemberOfCommunity = userIsMemberOfCurrentGroup(currentUser, community);
  const isHUStaff = !!currentUser && !!currentUser.roles && currentUser.roles.includes('HealthUnlocked');
  const isArchivedCommunityAndHUStaff = !!community && community.isArchived && isHUStaff;

  return (
    <div className="community-header__content">
      <div className="community-header__desc">
        <div className="community-header__logo">
          {isHUStaff
            ?
              <ImageUpload
                boundary={{ width: 120, height: 120 }}
                buttonText={i18n.t('Add logo')}
                className="community-header__logo-img"
                communitySlug={community.slug}
                currentImageUrl={imageUrl}
                fitBest={true}
                savePreviewLocally={true}
                onSave={saveAndCropLogoImage}
              />
            :
              <div
                className="community-header__logo-img"
                style={logoStyle}
              />
          }
        </div>
        <div className="community-header__desc-content">
          <h2 className="community-header__title">{community.name}</h2>
          {(!!community && community.isArchived) ?
            <div className="community-header__subtitle">
              <span>{numberFormat(community.postCount)} {i18n.t('posts')}</span>
              <span>{' • '}</span>
              <button
                className="btn community-header__archived-btn"
                onClick={() => useHelpScout('172-what-are-archived-communities')}
              >
                {i18n.t('Archived')}<span className="icon icon-information"/>
              </button>
            </div>
            :
           (!!currentUser || community.followerCount >= 300) && (
             <div className="community-header__subtitle">
               {numberFormat(community.followerCount)} {i18n.t('members')} • {numberFormat(community.postCount)} {i18n.t('posts')}
             </div>
           )}
        </div>
        {(isArchivedCommunityAndHUStaff || !community.isArchived) &&
          <div className="community-header__desc-actions">
            {isHUStaff
              ? <AdminActions/>
              : <FollowButton
                  community={community}
                  followType="group"
                  isActive={!!currentUser}
                  isFollowing={isMemberOfCommunity}
                  signupContext={{
                    element: signupContext.element.FOLLOW,
                    section: 'community-' + currentPage,
                  }}
                  user={currentUser}
                />
            }
            {isWriteCTAVisible(community) && (
              <WriteButton
                community={community}
                currentUser={currentUser}
                trackingSection={'community-' + currentPage}
              >
                {i18n.t('Write')}
              </WriteButton>
            )}
          </div>}
      </div>
    </div>
  );
};

CommunityHeaderContent.propTypes = {
  community: PropTypes.object,
  currentPage: PropTypes.string,
  currentUser: PropTypes.object,
};

CommunityHeaderContent.defaultProps = {
  community: {},
  currentPage: '',
  currentUser: {},
};

export default CommunityHeaderContent;
